import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import {
  AI_HUB_TAB_LABELS,
  buildAiHubConditionalTaggingResultPath,
  buildAiHubTaggingResultPath,
  type TaggingResultDetailRouteQuery,
} from "./constants";

type TaggingResultRowActionsProps = Readonly<{
  rowId: string;
  objectType: string;
  objectSubType: string;
  version: string;
  resultType?: "tagging" | "conditional";
}>;

export default function TaggingResultRowActions({
  rowId,
  objectType,
  objectSubType,
  version,
  resultType = "tagging",
}: TaggingResultRowActionsProps) {
  const navigate = useNavigate();
  const query: TaggingResultDetailRouteQuery = {
    objectType,
    objectSubType,
    version,
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <IconButton
        aria-label={`View ${
          resultType === "conditional"
            ? AI_HUB_TAB_LABELS.conditionalTaggingResult
            : AI_HUB_TAB_LABELS.taggingResult
        } ${rowId}`}
        size="small"
        sx={{ p: 0.75 }}
        onClick={(event) => {
          event.stopPropagation();
          navigate(
            resultType === "conditional"
              ? buildAiHubConditionalTaggingResultPath(rowId, query)
              : buildAiHubTaggingResultPath(rowId, query),
          );
        }}
      >
        <VisibilityOutlinedIcon sx={{ fontSize: 18, color: "#A6A6A6" }} />
      </IconButton>
    </Box>
  );
}
